import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useForm } from "react-hook-form";

import useModalHelper from '/src/components/modal/hooks/useModalHelper';
import Modal from '/src/components/modal/Modal';
import Form from "/src/components/form/Form";
import ButtonAction from "/src/components/UI/Button/Button";
import Field from '/src/components/UI/Field/Field';
import "./StatementColumnModal.css"
import TextInput from '/src/components/UI/TextField/TextInput';
import DropDown from '/src/components/UI/DropDown/DropDown';
import StatementColumnTypes from "../../../data/types/StatementColumnTypes";
import StatementColumnFormTypes from "../../../data/types/StatementColumnFormTypes";
import worksheetService from "../../../services/worksheetService";
import { useEffect, useState } from "react";
import useRegex from "../../hooks/useRegex";
const StatementColumnModal = NiceModal.create(({ column, dataset }) => {
    const modal = useModal();
    const { onClose } = useModalHelper(modal);
    var isAdding = column == null;

    const formData = StatementColumnFormTypes[isAdding ? "create" : "update"];

    const { addColumn, updateColumn } = worksheetService
    const {regex} = useRegex();
    const [listRegex, setRegex] = useState([])
    const { register, handleSubmit, getValues, setValue, watch, formState: { errors }, formState } = useForm({
        mode: "onChange",
        defaultValues: {
            name: isAdding ? "" : column.name,
            type: isAdding ? "keyword" : column.type,
            regex: isAdding ? "0" : column.rule,
        }
    })

    const onSubmit = async () => {
        if (isAdding == false) {
            setValue("index", column.index);
        }
        let dataToSend = getValues();
        dataToSend.name = dataToSend.name.trim()
        const [res, error] = isAdding ? await addColumn(dataset.id, dataToSend) : await updateColumn(dataset.id, dataToSend);
        if (error != null) {
            console.error(error);
            return;
        }

        modal.resolve();
        onClose();
    }

    const setUpRegex = async () => {
        let listRegex = [];
        listRegex.push({ text: <div style={{ width: "100%", textAlign: "center" }} > Nothing </div>, value: 0 });

        regex.forEach(reg =>
            listRegex.push({
                text: <div style={{ justifyContent: "start" }} ><i className={reg.icon} style={{ marginRight: "25px", color: "var(--main)" }}></i> {reg.name}</div>,
                value: reg.value
            })
        );
        setRegex(listRegex);

    }
    useEffect(() => {
        if (regex.length == 0) return;
        setUpRegex()
    }, [regex])
    return (
        <Modal name="change-password" id={modal.id} autoClose="true" onClose={onClose} >
            <Form className="statement_form_column_container" onSubmit={handleSubmit(onSubmit)}>

                <Form.Title>
                    {formData.title}
                </Form.Title>

                <Form.Body className={"statement_form_column_body"}>

                    <div className={"statement_form_column_title"}>
                        <Field label={"Column's name"} listLabelClassName="field-modal" />
                        <TextInput {...register('name', { required: true, minLength: 3 })} placeholder={"Enter the label of the column"} className={"statement_form_column_text_input"} style={errors.name ? { borderColor: "red" } : {}}></TextInput>
						<span className='error' style={{fontSize : "14px", marginTop:"5px", height :"10px"}}>{errors.name ? (errors.name.message ? errors.name.message : "At least 3 letters") : ""}</span>
                    </div>
                    <div className='statement_form_column_dropdown_container'>
                        <Field label="Type Column" listLabelClassName="titles-input"></Field>
                        <div style={{ marginLeft: "15%", marginTop: "2%" }}>
                            <DropDown {...register('type')} setValue={setValue} choices={StatementColumnTypes} defaultChoice={isAdding ? "keyword" : column.type} width="200px" disabled={!isAdding}></DropDown>
                        </div>
                        
                    </div>
                    {
                        listRegex.length > 0 &&
                        <div className='statement_form_column_dropdown_container' style={{ marginTop: "10%" }}>
                            <Field label="Type Regex" listLabelClassName="titles-input"></Field>
                            <div style={{ marginLeft: "15%", marginTop: "2%" }}>
                                <DropDown {...register('regex')} setValue={setValue} choices={listRegex} defaultChoice={isAdding ? "0" : column.rule} width="200px" reverse={true}></DropDown>
                            </div>
                        </div>
                    }

                </Form.Body>
                <Form.Buttons>
                    <ButtonAction className="cancel" label="Cancel" type="button" onClick={() => onClose()} style={{ marginRight: "20px" }} />
                    <ButtonAction className="validate" label={formData.send} type="submit" disabled={!formState.isValid} />

                </Form.Buttons>

            </Form>
        </Modal>
    );
});

export default StatementColumnModal;